// ============== This hides Globo Swatch when Kaching Bundle exist in PDP =============================

(function () {
  // Only run on product pages
  var isProductPage =
    window.location.pathname.indexOf('/products/') !== -1 ||
    (window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.pageType === 'product');

  if (!isProductPage) return;

  // Inject the CSS rule
  var style = document.createElement('style');
  style.textContent =
    'html.has-kaching-bundle .globo-swatch-product-detail { display: none !important; }';
  document.head.appendChild(style);

  function check() {
    if (document.querySelector('kaching-bundle[data-initialized="true"]')) {
      document.documentElement.classList.add('has-kaching-bundle');
      return true;
    }
    return false;
  }

  if (check()) return;

  // Watch for the element being added AND for data-initialized changing
  var observer = new MutationObserver(function () {
    if (check()) observer.disconnect();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-initialized']
  });

  // Stop watching after 10 seconds if it never becomes enabled
  setTimeout(function () { observer.disconnect(); }, 10000);
})();
// ============== This hides Globo Swatch when Kaching Bundle exist in PDP =============================




// ============== Fix sliding cart text not updating: Free Shipping =============================
(function () {
  const text = "Free Shipping!";

  function ampSetShippingText() {
    document.querySelectorAll(".amp-cart__footer-row--shipping-value").forEach(el => {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  function start() {
    ampSetShippingText();
    new MutationObserver(ampSetShippingText).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
// ============== Fix sliding cart text not updating: Free Shipping =============================